import styled from 'styled-components'
import SvgEmail from '@capture/capture-components/src/icons/Email'
import SvgGetLink from '@capture/capture-components/src/icons/GetLink'
import SvgSms from '@capture/capture-components/src/icons/Sms'
import { _ } from '~/assets/localization/util'
import { colors, fontSize } from '~/assets/styleConstants'
import type { SVGIcon } from '../Common/IconTextButton'

type Props = React.PropsWithChildren<{
    onClick?: () => void
    isDisabled?: boolean
}>
const IconWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`
const IconText = styled.span`
    color: ${colors.captureGrey500};
    font-size: ${fontSize.small_12};
    margin-top: 4px;
`

const DisabledIcon = styled.div`
    opacity: 0.5;

    & > svg {
        display: block;
    }
`

type ShareByOptionProps = Props & {
    icon: SVGIcon
    text: string
    iconColor?: string
}
const ShareByOption = ({
    icon: OptionIcon,
    text,
    iconColor,
    isDisabled,
    onClick,
    children,
}: ShareByOptionProps) => {
    let icon = <OptionIcon width={48} height={48} color={iconColor} />
    if (isDisabled === true) {
        icon = <DisabledIcon>{icon}</DisabledIcon>
    }
    return (
        <IconWrapper
            onClick={onClick}
            onKeyUp={onClick}
            role="button"
            tabIndex={0}>
            {icon}
            <IconText>{text}</IconText>
            {children}
        </IconWrapper>
    )
}

export const ShareByMailButton: React.FunctionComponent<Props> = (props) => (
    <ShareByOption icon={SvgEmail} text={_('email')} {...props} />
)
export const ShareBySMSButton: React.FunctionComponent<Props> = (props) => (
    <ShareByOption icon={SvgSms} text={_('SMS')} {...props} />
)

export const GetLinkButton: React.FunctionComponent<Props> = (props) => (
    <ShareByOption icon={SvgGetLink} text={_('get_link')} {...props} />
)
